import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { SigninComponent } from './signin/signin.component';
import { RealtimeComponent } from './pages/realtime/realtime.component';
import { DashboradComponent } from './pages/realtime/dashborad/dashborad.component';
import { PathComponent } from './pages/historical/path/path.component';
import { StopComponent } from './pages/historical/stop/stop.component';
import { MileageComponent } from './pages/historical/mileage/mileage.component';
import { OverspeedComponent } from './pages/historical/overspeed/overspeed.component';
import { InfoDeviceComponent } from './pages/realtime/popup-rt/info-device/info-device.component';
import { AlertNotificationComponent } from './pages/alert-management/alert-notification/alert-notification.component';
import { FuelDataComponent } from './pages/statistical/fuel-data/fuel-data.component';
import {VideoComponent} from "./pages/realtime/video/video.component";
import {VideoEmergencyComponent} from "./pages/video-emergency/video-emergency.component";
import {DriverComponent} from "./pages/driver/driver.component";
import {TrackControleComponent} from "./utils/leaflet/track-controle/track-controle.component";

const routes: Routes = [
  { path: '', redirectTo: '/signin', pathMatch: 'full' },
  {
    path: 'signin', component: SigninComponent
  },
  {
    path: 'client', component: RealtimeComponent,
  },
  {
    path: 'videoemergency', component: VideoEmergencyComponent,
  },
  {
    path: 'path', component: PathComponent,
  },
  {
    path: 'stop', component: StopComponent,
  },
  {
    path: 'mileage', component: MileageComponent,
  },
  {
    path: 'overspeed', component: OverspeedComponent,
  },
  {
    path: 'notification-details', component: AlertNotificationComponent,
  },
  {
    path: 'carburant', component: FuelDataComponent,
  },
  {
    path: 'camera', component: VideoComponent,
  },
  {
    path: 'driver', component: DriverComponent,
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
